import React, { FC } from 'react';
import { FieldError, Control, Controller } from 'react-hook-form';

type CustomInputProps = {
  name: string;
  type: string;
  label: string;
  placeholder?: string;
  hasIcon: boolean;
  divStyle?: string;
  labelStyle?: string;
  inputStyle?: string;
  icon?: React.ReactElement;
  onIconClick?: () => void;
  control: Control<any>;
  error: FieldError | undefined;
  onChange?: (value: any) => void;
  disabled?: boolean;
  maxLength?: number;
  mandatory?: boolean;
};

const CustomInput: FC<CustomInputProps> = ({
  name,
  type,
  label,
  placeholder,
  hasIcon,
  divStyle,
  labelStyle,
  inputStyle,
  icon,
  onIconClick,
  control,
  error,
  onChange,
  disabled,
  maxLength,
  mandatory = false,
}) => {
  return (
    <div className="flex flex-col w-full">
      <label htmlFor={name} className={labelStyle}>
        <span className="inline-flex items-center">
          {label}
          {mandatory ? <span className="ml-1">*</span> : null}
        </span>
      </label>
      <div className={`relative ${divStyle}`}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <input
              id={name}
              name={name}
              type={type}
              placeholder={placeholder}
              className={`${inputStyle} ${
                hasIcon ? 'pr-10' : '' // make room for the icon
              } ${
                disabled
                  ? 'bg-gray-100 text-gray-500 cursor-not-allowed opacity-70'
                  : ''
              } w-full`}
              value={field.value || ''}
              onChange={(event) => {
                const value =
                  type === 'number'
                    ? parseFloat(event.target.value)
                    : event.target.value;
                field.onChange(value);

                if (onChange) {
                  onChange(value);
                }
              }}
              disabled={disabled || false}
              maxLength={maxLength}
            />
          )}
        />
        {hasIcon && icon && (
          <div
            className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
            onClick={onIconClick}
          >
            {icon}
          </div>
        )}
      </div>

      {error && (
        <span className="text-red-600 w-full px-2 text-base text-wrap mt-1">
          {error.message}
        </span>
      )}
    </div>
  );
};

export default CustomInput;
